<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-header transparent  text-muted" >
          <h4 class="mb-0 font-header">Service Plan</h4>
        </div>
        <div class="card-body  widget-body pb-0 pt-2 mb-4">
          <div class="row align-items-center g-3">
            <!-- Service Plan Button -->
            <div class="col-12 col-md-5" *ngIf="logintype != 'onboardLogin'">
              <button
                type="button"
                class="btn btn-sm"
                [disabled]="global.viewTabs || !fp?.sdpcreate"
                (click)="serviceImport()"
              >
                Start Service Plan
              </button>

              <button
              type="button"
              class="btn btn-sm ms-2"  (click)="uploadSPD();"
              [disabled]="global.viewTabs || !fp?.sdpcreate"
            >
              Upload SDP
            </button>
                 <!-- Copy SDP Button -->
              <button
                type="button"
                class="btn btn-sm ms-2"
                [disabled]="global.viewTabs || singledata.length != 1"
                (click)="CopyServiceplan()"
              >
                Copy SDP
              </button>

            <!-- Approve and Unapprove Buttons -->
          
              <button
              class="btn blue-btn btn-sm ms-2 mb-1"
              [disabled]="planIds?.length == 0 || global.viewTabs  || !fp?.sdpapprove"
              (click)="planMarkedCheckbox(true)"
            >
              Approve
            </button>
            <button
              class="btn blue-btn btn-sm ms-2 mb-1"
              [disabled]="planIds?.length == 0 || global.viewTabs"
              (click)="planMarkedCheckbox(false)"
            >
              Unapprove
            </button>
            </div>
          
         
          
             <!-- <div class="col-12 col-md-2 d-flex flex-wrap">
             
            </div> -->
          
            <!-- Radio Buttons for Status -->
            <div class="col-12 col-md-2">
              <div class="d-flex flex-wrap">
                <label>
                  <input
                    type="radio"
                    class="me-1"
                    name="options"
                    [value]="'active'"
                    [(ngModel)]="status"
                    [disabled]="global.viewTabs"
                    (change)="statusChangeCall('active')"
                  />
                  Active
                </label>
                <label class="ms-3">
                  <input
                    type="radio"
                    class="me-1"
                    name="options"
                    [value]="'all'"
                    [(ngModel)]="status"
                    [disabled]="global.viewTabs"
                    (change)="statusChangeCall('all')"
                  />
                  All
                </label>
                <label class="ms-3">
                  <input
                    type="radio"
                    class="me-1"
                    name="options"
                    [value]="'expired'"
                    [(ngModel)]="status"
                    [disabled]="global.viewTabs"
                    (change)="statusChangeCall('expired')"
                  />
                  Expired
                </label>
              </div>
            </div>
          
            <!-- Radio Buttons for Approval Filter -->
            <div class="col-12 col-md-3">
              <div class="d-flex flex-wrap">
                <label>
                  <input
                    type="radio"
                    class="me-1"
                    name="all"
                    value="All"
                    id="VisitApprovedAll"
                    [disabled]="global.viewTabs"
                    [(ngModel)]="ApproveFilter"
                    (ngModelChange)="getServicePlanList()"
                  />
                  All
                </label>
                <label class="ms-3">
                  <input
                    type="radio"
                    class="me-1"
                    name="all"
                    value="Approve"
                    [disabled]="global.viewTabs"
                    [(ngModel)]="ApproveFilter"
                    (ngModelChange)="getServicePlanList()"
                    id="VisitApproved"
                  />
                  Approved
                </label>
                <label class="ms-3">
                  <input
                    type="radio"
                    class="me-1"
                    name="all"
                    value="NotApprove"
                    [disabled]="global.viewTabs"
                    [(ngModel)]="ApproveFilter"
                    (ngModelChange)="getServicePlanList()"
                    id="VisitNotApproved"
                  />
                  Not Approved
                </label>
              </div>
            </div>
          
            <!-- Refresh Button -->
            <div class="col-12 col-md-2">
              <button
                type="button"
                class="btn btn-sm"
                [disabled]="global.globalAgencyId == null || global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == '' || global.viewTabs"
                (click)="Refresh()"
              >
                <i class="fa fa-repeat me-2"></i>Refresh
              </button>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
  <!-- ////////////////////////////////////////////////////////////////////////////// -->
    
  <!-- /////////////////////////////////////////////////////////////////// -->
  <div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
  global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class="col pl-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2" > 
               <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update SDPTotalColumns constant in serviceplan.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'SDPGrid' maps to localStorage key 'gridSDPGrid'
                                                                          -->
                  <ejs-grid #grid  id="SDPGrid"  [dataSource]='data | async' [allowResizing]='true' [allowReordering]="true" 
                  [enablePersistence]="true"
                     [allowSorting]='true' allowPaging='true' [allowFiltering]='true'   *ngIf="global.globalAgencyId!='00000000-0000-0000-0000-000000000000'"
                    [pageSettings]='initialPage'   [filterSettings]='filterOptions'  (actionBegin)="onActionComplete($event)"
                    [showColumnChooser]='true' (checkBoxChange)="CheckboxChange($event)"
                    [selectionSettings]='selectionOptions'
                             [editSettings]='editSettings' (dataStateChange)='dataStateChange($event)' (resizeStop)="onResize($event)"
                      >
                      <!-- (dataStateChange)="datachangeonBoardEmp($event)" (actionBegin)="OnBoardActionComplete($event)/" -->
                      <e-columns>

                        <e-column type='checkbox' [showInColumnChooser]='false' uid="checkbox" width=50
                        textAlign='center' [allowEditing]='true' editType="booleanedit" [edit]='checkparams'>
                      </e-column>
                        <e-column width= 200  uid="action" headerText="Actions" textAlign="center" [showInColumnChooser]='false'
                        [allowEditing]='false'>
                          <ng-template #template let-data>  
                            <button class="btn btn-edit-table me-2" *ngIf="!data.isUploaded"  [disabled]="global.viewTabs || !fp?.sdpupdate"  data-bs-toggle="modal" data-bs-target="#DocumentsAdd"
                            (click)="editServiceplan(data)"><i class="fa fa-edit"></i></button>  
                            <button class="btn btn-edit-table me-2" [disabled]="global.viewTabs || !fp?.sdpupdate" *ngIf="data.isUploaded" 
                            (click)="editUploadSDP(data)"><i class="fa fa-edit"></i></button>  
                            <button class="btn btn-delete-table me-2" *ngIf="logintype !='onboardLogin'" 
                            [disabled]="global.viewTabs  || !fp?.sdpdelete" data-bs-toggle="modal" data-bs-target="#deletemodal" 
                            (click)="DeleteServicePlanDetails(data)"><i class="fa fa-trash"></i></button>

                              <!-- Download Button (Visible if isUploaded is true) -->
                            <button class="btn btn-edit-table me-2" *ngIf="data.isUploaded" (click)="downloadFile(data)">
                              <i class="fa fa-download"></i>
                            </button>
                            
                            <!-- View Button (Visible if isUploaded is true) -->
                            <!-- <button class="btn btn-edit-table me-2" *ngIf="data.isUploaded" (click)="viewFile(data.serviceDeliveryPlanId)">
                              <i class="fa fa-eye"></i>
                            </button> -->
                       </ng-template>
                        </e-column>

                          <!-- isApproved -->
                          <e-column field='isApproved' headerText="Approved"
                          textAlign='center' [allowEditing]='false'
                          [allowSorting]='false' [allowFiltering]='false'>
                          <ng-template #template let-data>
                              <i class="fa fa-check" *ngIf="data.isApproved"
                                  style="font-size:27px;color:green"></i>

                          </ng-template>
                      </e-column>
                      <e-column field='isUploaded' headerText="SDP Uploaded"
                      textAlign='center' [allowEditing]='false'
                      [allowSorting]='false' [allowFiltering]='false'>
                      <ng-template #template let-data>
                        {{ data.isUploaded ? 'Yes' : 'No' }}
                      </ng-template>
                  </e-column>
                        <e-column width= 100 field="clientName" headerText="Client Name" type="string"
                        [allowEditing]='false'>
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column width= 100 field="startdate" headerText="Start Date" type="date"
                        [allowEditing]='false' [allowFiltering]='false' [format]="formatOptions" >
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column width= 100 field="enddate" headerText="End Date" type="date" 
                        [allowEditing]='false' [allowFiltering]='false' [format]="formatOptions" >
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                       
                        <e-column width= 100 field="modeltypeName" headerText="Model" type="string" 
                        [allowEditing]='false'>
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>

                        <e-column width= 100 field="version" headerText="Plan Type" type="string"  [allowEditing]='false'>
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column width= 100 field="plandate" [allowFiltering]='false'
                        [allowEditing]='false' headerText="Plan Date" type="date" [format]="formatOptions">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>

                        <e-column width= 100 field="createdTime" [allowFiltering]='false'
                        [allowEditing]='false' headerText="Created Date" type="date" [format]="formatOptions">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>

                        <e-column width= 100 field="modifiedTime" [allowFiltering]='false' 
                        [allowEditing]='false' headerText="Modified Date" type="date" [format]="formatOptions">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>

                        <e-column width= 100 field="createdBy" headerText="Created By" type="string" [allowSorting]='false'  [allowEditing]='false'>
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>

                        <e-column width= 100 field="modifiedBy" headerText="Modified By" type="string" [allowSorting]='false'   [allowEditing]='false' >
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <!-- <e-column width= 100 field="totalAmt" headerText="Total Amount" type="string">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column width= 100 field="unusedAmt" headerText="Unused Amount" type="string">
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>
                        <e-column width= 100 field="lastupdateddate" headerText="Last modified Date" type="date" [format]="formatOptions" >
                          <ng-template #filterTemplate let-data>
                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                          </ng-template>
                        </e-column>                              -->
                    
                        <!--------------------------------table header icon---------------->
                        <e-column width="50" [showInColumnChooser]='false'>
                          <ng-template #headerTemplate let-data>
                            <div>
                            <span id='show' ><i  class="fa fa-cog fa-lg" aria-hidden="true" (click)='show()'>
                                              </i>
                            </span>
                            </div>
                          </ng-template>
                        </e-column>
                      </e-columns>
                    </ejs-grid>
                     <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update SDPTotalColumns constant in serviceplan.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'SDPGrid' maps to localStorage key 'gridSDPGrid'
                                                                          -->
            </div>
        </div>
    </div>
  </div>


 

<!--slect Agency message-->
<div class="row mb-2" *ngIf="global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
  <div class="col pl-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body pt-2">
        <div class="text-center text-danger pt-3">
          <label class="font-red " style="font-size: 13px;"><i class="fa fa-info-circle fa-lg mr-1"></i>&nbsp;Select agency to view details</label>
        </div>
      </div>
    </div>
  </div> 
</div>  

<span id="openModal2" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deletemodal" data-bs-backdrop="static">
  <div class="modal-dialog delete-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Delete Record</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this record ?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm"
          (click)="DeleteServiceplan()">Delete</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
<app-serviceplan-form  *ngIf="ServicePlanImportData.edit" [serviceImprtPlan]="serviceImprtPlan" (dataEmitFromCDCSPlan)="dataEmitFromCDCSPlan($event)"
[servicePlan]="ServicePlanImportData"  ></app-serviceplan-form>

 
<!-- <app-budgetplan-form  *ngIf="BudgetImportData.edit" [budgetImprtPlan]="budgetImprtPlan" (dataEmitFromCDCSPlan)="dataEmitFromCDCSPlan($event)"
 [budgetPlan]="BudgetImportData"  [BudgetView]="Basic" ></app-budgetplan-form> -->

       
 <span id="templateNameModal" data-bs-toggle="modal" data-bs-target="#templateModal"></span>
<div class="modal fade modalbackgrod" id="templateModal" tabindex="-1" aria-labelledby="templateModalLabel"
  aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="templateModalLabel"> Upload Service Delivery Plan</h5>

        <div class="col-lg- 2col-md-2 col-sm-3 ms-5  "   *ngIf="sdpupload.serviceDeliveryPlanId !='00000000-0000-0000-0000-000000000000' && logintype !='onboardLogin'">
                       
          <button *ngIf="!isevent" class="btn blue-btn btn-sm mr-1" type="button" [disabled]="eventdisable"
          (click)="checkvalidation()" data-bs-toggle="modal" data-bs-target="#createevent">
          Create Events</button>
          <button *ngIf="isevent" class="btn blue-btn btn-sm mr-1" type="button" 
           (click)="sendEventdata();viewevent=true;">
          Manage Events</button>
      </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" ></button>
      </div>
      <div class="modal-body">
      
        <div class="row mt-4" style="margin-bottom:5px">
          <div class="col-lg-5">
            <label>File<sup class="super-script">&nbsp;*&nbsp;</sup> </label>
          </div>
          <div class="col-lg-7">
            <div class="input-group mb-3">
              <input type="file" class="form-control" id="inputGroupFile02"  [disabled]="sdpupload.serviceDeliveryPlanId !== '00000000-0000-0000-0000-000000000000'"
                (change)="onDOCFileChanged($event.target.files)" [(ngModel)]="sdpupload.sdpDocFilepath"
                accept="application/pdf">
            </div>

          </div>
          <div class="row">
            <div class="col-lg-5">
            </div>
            <div class="col-lg-7 ">
              <label style="color: #386AAB;width: -webkit-fill-available">{{selectedDocumentFileName}}</label>
            </div>
          </div>


        </div>
        <div class="row">
            <div class="col-5"> <label>Plan date<sup class="super-script">&nbsp;*&nbsp;</sup> </label></div>
            <div class="col-7">
              <my-date-picker [options]="myDatePickerOptions"
              [selDate]="sdpupload.plandate" placeholder="mm/dd/yyyy"
              (inputFieldChanged)="newdates($event,'inputchage','plandate');"
              
              (dateChanged)="newdates($event,'datechagned','plandate')" 
              [disabled]="logintype =='onboardLogin'">

          </my-date-picker>
            </div>

        </div>
        <div class="row">
          <div class="col-5"> <label>Start date<sup class="super-script">&nbsp;*&nbsp;</sup> </label></div>
          <div class="col-7">
            <my-date-picker [options]="myDatePickerOptions"
            [selDate]="sdpupload.startdate" placeholder="mm/dd/yyyy"
            (inputFieldChanged)="newdates($event,'inputchage','startdate')"
            (dateChanged)="newdates($event,'datechagned','startdate')" [disabled]="logintype =='onboardLogin'">

        </my-date-picker> 
          </div>
        </div>
        <div class="row">
          <div class="col-5"> <label>End date<sup class="super-script">&nbsp;*&nbsp;</sup> </label></div>
          <div class="col-7">
            <my-date-picker [options]="myDatePickerOptions"
            [selDate]="sdpupload.enddate" placeholder="mm/dd/yyyy"
            (inputFieldChanged)="newdates($event,'inputchage','enddate')"
            (dateChanged)="newdates($event,'datechagned','enddate')" [disabled]="logintype =='onboardLogin'">

        </my-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-5"> <label>Version<sup class="super-script">&nbsp;*&nbsp;</sup> </label></div>
          <div class="col-7">
            <input type="radio" class="ml-2" name="status" [value]="'New'"
            [(ngModel)]="sdpupload.version"   [disabled]="logintype =='onboardLogin'" /> New &nbsp;
        <input type="radio" class="ml-2" name="status" [value]="'Revised'"
            [(ngModel)]="sdpupload.version"   [disabled]="logintype =='onboardLogin'" />Revised &nbsp;
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-5"> <label>Total CFSS Units<sup class="super-script">&nbsp;*&nbsp;</sup> </label></div>
          <div class="col-7">
            <input class="form-control" type="number"
          
            [(ngModel)]="sdpupload.totalCFSSUnitsEligible"  [disabled]="logintype =='onboardLogin'">
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-5"> <label>Model<sup class="super-script">&nbsp;*&nbsp;</sup> </label></div>
          <div class="col-7">  <ng-select class="w-100" [(ngModel)]="sdpupload.modelTypename" [searchable]="true" [clearable]="true"
            [items]="modelTypename" [disabled]="logintype =='onboardLogin'" >
          </ng-select></div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm" (click)="savesdp(sdpupload)" [disabled]="!sdpupload.plandate || !sdpupload.startdate || !sdpupload.enddate || 
                                !selectedDocumentFileName || !sdpupload.totalCFSSUnitsEligible || 
                                !sdpupload.modelTypename || !sdpupload.version" *ngIf="logintype !='onboardLogin' ">
            <span *ngIf="sdpupload.serviceDeliveryPlanId == '00000000-0000-0000-0000-000000000000'">Save</span>
            <span *ngIf="sdpupload.serviceDeliveryPlanId !== '00000000-0000-0000-0000-000000000000'">Update</span>
          </button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<span id="ViewHandbook22" data-bs-target="#ViewHandbookmodal1" data-bs-toggle="modal"></span>
<div class="modal fade" id="ViewHandbookmodal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header card-show">
        <div class="col-lg-3">
          <h5 class="modal-title font-header" id="exampleModalLabel">View Document<span>
            </span> </h5>
        </div>
        <div class="col-lg-7 text-end">
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

      </div>
      <div class="modal-body" *ngIf="pdfsrc!=null && pdfsrc!=undefined && pdfsrc!=''">
        <iframe [src]="pdfsrc" width="100%" height="600px"></iframe>

      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>

<!-- Trigger -->
<span id="createeventTrigger" data-bs-toggle="modal" data-bs-target="#createevent"></span>

<!-- Modal -->
<div class="modal fade" id="createevent" data-bs-backdrop="static">
    <div class="modal-dialog mw-100" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Create Event</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row mt-2">
                            <div class="table-responsive" style="max-height: 500px; overflow-y: auto;  min-height: 274px;">
                                <table class="table table-hover">
                                    <thead>
                                        <tr style="border: 1px gray;">
                                            <th style="min-width: 200px;"><b>Client Name</b></th>
                                            <th style="min-width: 200px;"><b>Employee Name <span class="text-danger">*</span></b></th>
                                            <th style="min-width: 200px;"><b>Start Date <span class="text-danger">*</span></b></th>
                                            <th style="min-width: 200px;"><b>End Date <span class="text-danger">*</span></b></th>
                                            <th style="min-width: 300px;"><b>Event Title <span class="text-danger">*</span></b></th>
                                            <th style="min-width: 300px;"><b>Event Description</b></th>
                                            <th style="min-width: 200px;"><b>Event Status <span class="text-danger">*</span></b></th>
                                            <th style="min-width: 200px;"><b>Plan Model</b></th>
                                            <th style="min-width: 300px;"><b>Languages</b></th>
                                            <th style="min-width: 300px;"><b>Type of Contact</b></th>
                                            <th style="min-width: 300px;"><b>Type of session</b></th>
                                            <th style="min-width: 300px;"><b>Event Alert</b></th>
                                            <th style="min-width: 150px;"><b>Reminder</b></th>
                                            <th style="min-width: 100px;"><b>Actions</b></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="border: 1px gray;" *ngFor="let event of GridDataEvent; let i = index">
                                            <td><input type="text" class="form-control" [(ngModel)]="event.clientName" [disabled]="true"></td>
                                            <td>
                                                <ng-select [(ngModel)]="event.consultantId" [searchable]="true" 
                                                    [clearable]="true" [items]="UserDropDownList" bindLabel="Value" bindValue="Key"
                                                    >
                                                </ng-select>
                                            </td>
                                            <td>
                                                <input type="datetime-local" class="form-control" [(ngModel)]="event.startTime" (change)="validateEventTimes();OutBoundCall(event, event.startTime, event.endTime)">
                            
                                            </td>
                                            <td>
                                                <input type="datetime-local" class="form-control" [(ngModel)]="event.endTime" (change)="validateEventTimes()">
                                                <div *ngIf="event.isOverlapping" class="text-danger">Event times cannot overlap</div>
                                                <div *ngIf="event.isInvalid" class="text-danger">End time must be after start time</div>
                                            </td>
                                            
                                            <td>
                                                   <textarea rows="7" [(ngModel)]="event.eventTitle"
                                                   class="form-control" cols="190"></textarea>
                                            </td>
                                            <td>
                                                <textarea rows="7" [(ngModel)]="event.eventDescription"
                                                    class="form-control" cols="190"></textarea>
                                            </td>
                                            <td>
                                                <ng-select [(ngModel)]="event.statusLid" [searchable]="true" 
                                                    [clearable]="true" [items]="StatusList" bindLabel="lovName" bindValue="id"
                                                    [ngClass]="{'is-invalid': submitted && !event.statusLid}">
                                                </ng-select>
                                            </td>
                                            <td>
                                                <ng-select [(ngModel)]="event.cfssModel" [searchable]="true"
                                                    [clearable]="true" [items]="cfssModel" [disabled]="true">
                                                </ng-select>
                                            </td>
                                            <td>
                                                <ng-select [(ngModel)]="event.languageListIds" [searchable]="true"
                                                    [clearable]="true" [multiple]="true" [items]="languageList" bindLabel="languageName"
                                                    bindValue="id" name="languageIds">
                                                </ng-select>
                                            </td>
                                            <td>
                                                <ng-select [(ngModel)]="event.typeofContactId"
                                                [searchable]="true" class="w-100" [clearable]="true"
                                                [items]="ContactList" bindLabel="lovName" bindValue="id">
                                            </ng-select>
                                            </td>
                                            <td>
                                                <ng-select [searchable]="true" class="w-100" [clearable]="true" [items]="ServiceList"
                                                    [(ngModel)]="event.typeofServiceId" bindLabel="serviceCode" bindValue="id">
                                                </ng-select>
                                            </td>
                                            <td>
                                                <ng-select [(ngModel)]="event.eventAlterList" [items]="EventList" bindLabel="eventAlterName" bindValue="eventAlertId"
                                                [multiple]="true" class="w-100" [compareWith]="compareEventAlerts"
                                                (change)="updateSelectedEventAlerts(event)">
                                            </ng-select>

                                            </td>
                                             <td>
                                               <input type="checkbox" 
                                                      [(ngModel)]="event.getConfirmation" 
                                                      [disabled]="event.isCheckboxDisabled"
                                                      class="w-100">
                                               <div *ngIf="event.noCallMessage" class="text-danger small">
                                                   {{event.noCallMessage}}
                                                 </div>
                                             </td>
                                            <td class="d-flex">
                                                <i style="font-size: 27px;" *ngIf="GridDataEvent.length > 1" (click)="removeEvent(i)"
                                                    class="fa fa-trash text-danger me-2"></i>
                                                <i class="fa fa-plus-circle text-primary" *ngIf="i == GridDataEvent.length - 1"
                                                    style="font-size: 30px" (click)="addEvent()"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                            </div>
                        </div>
            
            
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="saveEvent();">Save</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="manageeventTrigger" data-bs-toggle="modal" data-bs-target="#manageevent"></span>

<!-- Modal -->
<div class="modal fade" id="manageevent" data-bs-backdrop="static">
    <div class="modal-dialog mw-100" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Events</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <app-events *ngIf="viewevent" >

                    </app-events>
                    </div>
            </div>
            <div class="modal-footer">
                <!-- <button type="button" class="btn blue-btn btn-sm" (click)="saveEvent();">Save</button> -->
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

